<form [formGroup]="jobOfferForm">
    <div class="main-create-job-offer">
        <div id="content" class="main-content" role="main"> 
            
            <div class="step-indicator hideInMobile">
                <div class="step initial-step" [class.active]="step >= 1" (click)="goToStep(1)">{{ 'createJobOffer.step2.steps.step1' | translate }}</div>
                <div class="step" [class.active]="step >= 2" (click)="goToStep(2)">{{ 'createJobOffer.step2.steps.step2' | translate }}</div>
                <div class="step final-step" [class.active]="step >= 3">{{ 'createJobOffer.step2.steps.step3' | translate }}</div>
            </div>

            <div class="step-indicator hideInDesktop">
                <div class="step initial-step" [class.active]="step >= 1" (click)="goToStep(1)">{{ 'createJobOffer.step2.steps.step' | translate }} 1</div>
                <div class="step" [class.active]="step >= 2" (click)="goToStep(2)">{{ 'createJobOffer.step2.steps.step' | translate }} 2</div>
                <div class="step final-step" [class.active]="step >= 3" (click)="goToStep(3)">{{ 'createJobOffer.step2.steps.step' | translate }} 3</div>
            </div>

            <h2>{{ 'createJobOffer.step3.title' | translate }}</h2>
                <section>
                    <p><span [innerHTML]="'createJobOffer.step3.intro' | translate"></span></p>
                    <h4>{{ 'createJobOffer.step3.department.title' | translate }}</h4>
                    <p [innerHTML]="'createJobOffer.step3.department.description' | translate"></p>
                    <div class="message-saved" *ngIf="message_saved">
                        <p>{{message_saved}}</p>
                    </div>
                    <div class="row hideInMobileDiv" style="padding-top: 20px; padding-bottom: 20px;">
                        <button  *ngFor="let category of selectedCualitiesDepartment | keyvalue"
                        style="padding: 12px; margin: 6px;"
                        type="button"
                        (click)="addcategory(category.key)"
                        [ngClass]="{'selected_chip': jobOfferForm.get('Cualities_department')?.value.includes(category.key), 'unselected_chip': !jobOfferForm.get('Cualities_department')?.value.includes(category.key)}"
                        >{{ category.value }}</button>
                    </div>

                    <div class="row hideInDesktopDiv extra-select">
                        <mat-form-field appearance="fill" class="width-variable" style="width: 100%;">
                            <mat-label>{{ 'createJobOffer.step3.department.selectPlaceholder' | translate }}</mat-label>
                            <mat-select formControlName="Cualities_department" multiple="true">
                                <mat-option *ngFor="let category of selectedCualitiesDepartment | keyvalue" [value]="category.key">
                                    {{ category.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    
                    <div class="row">
                        <p>{{ 'createJobOffer.step3.department.addCustom' | translate }}</p>
                    </div>
                    <div class="row">
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'createJobOffer.step3.department.addCustomPlaceholder' | translate }}</mat-label>
                            <input matInput formControlName="Other_cualities">
                        </mat-form-field>
                    </div>
                    <div *ngIf="jobOfferForm.get('Cualities_department')?.value.length === 0 && jobOfferForm.get('Cualities_department')?.touched" class="formError">
                        <p>
                            {{ 'createJobOffer.step3.department.error' | translate }}
                        </p>
                    </div>
                
                </section>
                <section class="section-margin-variable">
                    <h4>{{ 'createJobOffer.step3.leadership.title' | translate }}</h4>
                    <p>{{ 'createJobOffer.step3.leadership.description' | translate }}</p>

                    <div class="row2">
                        <div class="column2">
                            <p class="subtitle">{{ 'createJobOffer.step3.leadership.personality.title' | translate }}</p>
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step3.leadership.personality.placeholder' | translate }}</mat-label>
                                <mat-select formControlName="personality" multiple="false">
                                    <mat-option *ngFor="let category of rasgos | keyvalue" [value]="category.key">
                                        <span style="font-weight: 500;">{{ category.value }}:</span> {{ descripcion_rasgos[category.key] }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div *ngIf="jobOfferForm.get('personality')?.hasError('required') && jobOfferForm.get('personality')?.touched" class="formError">
                                <p>
                                    {{ 'createJobOffer.step3.leadership.personality.error' | translate }}
                                </p>
                            </div>
                        </div>

                        <div class="column2" >
                            <p class="subtitle">{{ 'createJobOffer.step3.leadership.behavior.title' | translate }}</p>
                            <mat-form-field appearance="fill" style="width: 100%">
                                <mat-label>{{ 'createJobOffer.step3.leadership.behavior.placeholder' | translate }}</mat-label>
                                <mat-select formControlName="behavior" multiple="false">
                                    <mat-option *ngFor="let category of comportamientos | keyvalue" [value]="category.key">
                                       <span style="font-weight: 500;">{{ category.value }}:</span> {{ descripcion_comportamientos[category.key] }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div *ngIf="jobOfferForm.get('behavior')?.hasError('required') && jobOfferForm.get('behavior')?.touched" class="formError">
                                <p>
                                    {{ 'createJobOffer.step3.leadership.behavior.error' | translate }}
                                </p>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row2" style="margin-top: 15px;">
                        <div class="column2">
                            <p class="subtitle">{{ 'createJobOffer.step3.leadership.management.title' | translate }}</p>
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step3.leadership.management.placeholder' | translate }}</mat-label>
                                <mat-select formControlName="management" multiple="false">
                                    <mat-option *ngFor="let category of gestiones | keyvalue" [value]="category.key">
                                        <span style="font-weight: 500;">{{ category.value }}:</span> {{ descripcion_gestiones[category.key] }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div *ngIf="jobOfferForm.get('management')?.hasError('required') && jobOfferForm.get('management')?.touched" class="formError">
                                <p>
                                    {{ 'createJobOffer.step3.leadership.management.error' | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="actions two-actions" style="margin-top: 20%; padding-bottom: 5%;">
                    <div class = "actions-left">
                        <button mat-raised-button color="primary" type="button"  class = "light-button" (click)="goBack()">
                            <span  *ngIf="!loading">{{ 'createJobOffer.step3.actions.back' | translate }}</span>
                            <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'createJobOffer.step3.actions.loading' | translate"></div>
                         </button>
                    </div>
                    <div class = "actions-right">
                        <button mat-raised-button color="primary" type="button"  class = "light-button" style="margin-right: 15px;" (click)="save_progress()">
                            <span  *ngIf="!loading">{{ 'createJobOffer.step3.actions.save' | translate }}</span>
                            <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'createJobOffer.step3.actions.loading' | translate"></div>
                         </button>
                        <button mat-raised-button color="primary" type="button" class = "linkedin-button" (click)="nextStep()">
                            <span  *ngIf="!loading">{{ 'createJobOffer.step3.actions.continue' | translate }}</span>
                            <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'createJobOffer.step3.actions.loading' | translate"></div>
                        </button>
        
                    </div>
                    
                </div>
        </div>
    </div>
</form>